export function normalizeUrl(url: string): string {
    if (url.startsWith('http')) return url;
    if (url.startsWith('mailto')) return url;

    return `https://microsoft.sharepoint.com${url}`;
}
